/* eslint @typescript-eslint/explicit-function-return-type: off */

export const responseReader = (response) => response.body.getReader();
